import request from "@/common/request"
import { EtiquetaDePreco, FormEtiquetaDePreco } from "@/models/EtiquetaDePreco"

const PATH = '/etiquetas'

export const create = async (data: FormEtiquetaDePreco): Promise<EtiquetaDePreco> =>
	await request.post(`${PATH}`, data)